module.exports = __webpack_public_path__ + "img/feed-a-child-3.4adbfc63.jpg";